import React from 'react'
import NextStep from './NextStep'
import AvailableMethods from '../Components/AvailableMethods'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import SubmitBtn from '../Components/SubmitBtn'
import ZLPCon from '$Deposits/Components/ZLP'


class ZLP extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        return (
            <div className='methodsActive'>
                <ZLPCon
                    AvailableMethods={AvailableMethods}
                    MoneyInput={MoneyInput}
                    SubmitBtn={SubmitBtn}
                    NextStep={NextStep}
                    SuccessPage={SuccessPage}
                />
            </div>

        );
    }
}

export default ZLP

